var path = 'infrastructure/directives/views/help-button.html';
var html = "<div style=position:relative;z-index:100;float:right> <a style=position:absolute;right:0;margin-top:-5px href=\"\" ng-click=helpManager.toggleHelp() ng-show=helpManager.hasHelp()> <i class=context-help-available ng-class=\"{ 'help-enabled': helpManager.isHelpVisible }\" title=\"Show or hide context sensitive help\"></i> </a> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/views/help-button.html
// module id = 2988427911024827
// module chunks = 1